import React, { useEffect, useRef } from 'react'
import { Box, Chip, Divider, Grid, Link, Paper, Typography } from '@mui/material'
import { GoogleLocation } from './GoogleLocation'
import CalendarTodayIcon from '@mui/icons-material/CalendarToday'
import PropTypes from 'prop-types'

const tarifs1 = [
  'Tarif standard : 15€',
  "Tarif prévente (jusqu'au 31 octobre 2026) : 12€",
  'Tarif seniors : 12€',
  'Tarif étudiants : 12€',
  'Tarif Passeport ABCD : 11€'
]

let salleDelvaux = {}
salleDelvaux.location = 'Salle Delvaux (Campus ULB du Solbosch), Avenue Paul Héger, 22. 1050 Bruxelles'
let karreveld = {}
karreveld.location = 'Château du Karreveld, Av. Jean de la Hoese 32, 1080 Molenbeek-Saint-Jean'
let archipel = {}
archipel.location = "Centre culturel Archipel 19 Pl. de l'Eglise 15, 1082 Bruxelles"

export default function Shows({ setSelectedTab, scrollToShow }) {
  const showRef1 = useRef(null)
  const showRef2 = useRef(null)
  const showRef3 = useRef(null)

  useEffect(() => {
    // Scroll to specific show if requested
    if (scrollToShow) {
      let targetRef = null
      switch (scrollToShow) {
        case 'commeEn14':
          targetRef = showRef1
          break
        case 'exVoto':
          targetRef = showRef2
          break
        case 'repasDesFauves':
          targetRef = showRef3
          break
        default:
          return
      }

      if (targetRef.current) {
        targetRef.current.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }, [scrollToShow])

  return (
    <div style={{ textAlign: 'center', width: '100%' }}>
      <Typography variant='h4' component='h2' gutterBottom align='center' sx={(theme) => ({ color: theme.palette.title.main })}>
        🎭 Spectacles à venir🎭
      </Typography>

      <Paper
        elevation={2}
        sx={{
          width: '100%'
        }}
      >
        {/* Divider */}
        <Grid item size={12}>
          <Divider sx={{ bgcolor: 'secondary.light' }} />
        </Grid>
        <Grid container spacing={2}>
          {/* Ex-Voto show */}
          <Grid ref={showRef2} size={{ xs: 12, sm: 4 }} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Box
              component='img'
              src='/CDS_ExVoto_Flyer_Recto.jpg'
              alt='Affiche du spectacle EX-VOTO'
              sx={{ width: '100%', maxWidth: 400, height: 'auto', borderRadius: 1, ml: 2 }}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 8 }} sx={{ p: 3, position: 'relative' }}>
            <Typography
              variant='h6'
              color='text.secondary'
              sx={{
                position: 'absolute',
                top: 6,
                right: 24,
                fontStyle: 'bold'
              }}
            >
              Saison 2026–2027
            </Typography>
            <Typography paragraph sx={{ textAlign: 'left', mt: 4 }}>
              Après les succès de Intra Muros d&rsquo;Alexis Michalik en 2025 et de Comme en 14! de Dany Laurent cette année, venez
              découvrir le troisième spectacle de la compagnie Clair de Scène en novembre 2026. Un projet plus intimiste laissant la place à
              un duo sur scène aussi percutant que touchant.
            </Typography>
            <Typography paragraph sx={{ textAlign: 'left' }}>
              <strong style={{ fontSize: '1.2em' }}>EX-VOTO</strong> de Xavier Durringer, dans une mise en scène de Patrice Lerch.
            </Typography>
            <Typography paragraph sx={{ textAlign: 'left', p: 3, fontFamily: 'Georgia, serif' }}>
              Assis de dos face au destin, Gus et Léa contemplent la sépulture de Jeff Bayley, le chanteur rock qui les a réunis. Le couple
              rejoue le film de sa vie : les passions électriques, les rages, les galères et cet inextinguible désir de survie. Ex-Voto est
              une traversée tendre et rock, une prière de fortune pour toutes les personnes qui cherchent encore un endroit où poser leur
              amour.
            </Typography>
            <Typography component='div' sx={{ textAlign: 'left' }}>
              <GoogleLocation show={salleDelvaux} />
            </Typography>
            <Typography sx={{ textAlign: 'left' }}>
              <CalendarTodayIcon
                color='action'
                sx={{
                  mr: 2,
                  color: 'primary.main'
                }}
              />
              Les 6 et 7 novembre 2026 à 20h00, Le 8 novembre 2026 à 15h00
            </Typography>
            <Typography component='div' sx={{ mt: 1, textAlign: 'left' }}>
              Réservations:
              <ul>
                <li>
                  directement via ce site{' '}
                  <Chip
                    onClick={() => setSelectedTab('3')}
                    clickable
                    label='Réservations'
                    color='secondary'
                    size='small'
                    sx={{ ml: 1, cursor: 'pointer' }}
                  />{' '}
                </li>
                <li>
                  par mail à{' '}
                  <Link href='mailto:clairdescene@hotmail.com' color='primary'>
                    clairdescene@hotmail.com
                  </Link>
                </li>
                <li>
                  par téléphone au{' '}
                  <Link href='tel:+32494066226' color='primary'>
                    +32 (0)494/06.62.26
                  </Link>
                </li>
              </ul>
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mt: 1, ml: 3 }}>
              {tarifs1.map((tarif) => (
                <Typography key={tarif} sx={{ textAlign: 'left' }}>
                  {tarif}
                </Typography>
              ))}
            </Box>
          </Grid>

          {/* Divider */}
          <Grid item size={12}>
            <Divider sx={{ bgcolor: 'secondary.light' }} />
          </Grid>

          {/* Le Repas des Fauves show */}
          <Grid ref={showRef3} size={{ xs: 12, sm: 8 }} sx={{ p: 3, position: 'relative' }}>
            <Typography
              variant='h6'
              color='text.secondary'
              sx={{
                position: 'absolute',
                top: 6,
                left: 24,
                fontStyle: 'bold'
              }}
            >
              Saison 2026–2027
            </Typography>
            <Typography paragraph sx={{ textAlign: 'left', mt: 4 }}>
              <strong style={{ fontSize: '1.2em' }}>LE REPAS DES FAUVES</strong>
            </Typography>
            <Typography paragraph sx={{ textAlign: 'left', p: 3, fontFamily: 'Georgia, serif' }}>
              Nous sommes à Paris en 1942. Sept amis, sous l’occupation allemande se retrouvent pour fêter l’anniversaire de Sophie. La
              soirée se déroule sous les meilleurs auspices. Soudainement au dehors, deux officiers allemands sont abattus. C’est alors que
              le Cdt Kaubach surgit parmi les convives et exige deux otages en guise de représailles. C’est avec un total mépris que le Cdt
              Kaubach décide de les laisser finir leur diner. Il repassera au moment du dessert prendre ses otages; Mais il leur laisse le
              champ libre puisqu’ils auront à choisir eux-mêmes les deux otages qui le suivront. Entre les sept « amis », le dialogue
              s’engage… âpre, dur, sans pitié ni concessions. Dégoulinant de veulerie, suintant d’une lâcheté bien compréhensible, le Repas
              des Fauves devient un chacun pour soi où tous les coups sont permis. Cette comédie dramatique grinçante, cependant non dénuée
              d’humour, ne cesse de rebondir : les caractères se dévoilent, les vernis éclatent et les révélations fusent. Qui mérite de
              survivre ? Qui peut être sacrifié ? Vivre ou mourir ?
            </Typography>
            <Typography component='div' sx={{ textAlign: 'left' }}>
              <GoogleLocation show={archipel} />
            </Typography>
            <Typography sx={{ textAlign: 'left' }}>
              <CalendarTodayIcon
                color='action'
                sx={{
                  mr: 2,
                  color: 'primary.main'
                }}
              />
              Les 8, 9, 10 et 11 avril 2027
            </Typography>
            <Typography component='div' sx={{ mt: 2, textAlign: 'left' }}>
              Réservations: <i>Plus d&apos;infos bientôt</i>
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, sm: 4 }} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Box
              component='img'
              src='/repasDesFauves.jpeg'
              alt='Affiche du spectacle Le Repas des fauves'
              sx={{ width: '100%', maxWidth: 300, height: 'auto', borderRadius: 1, ml: 2 }}
            />
          </Grid>

          {/* Divider */}
          <Grid item size={12}>
            <Divider sx={{ bgcolor: 'secondary.light' }} />
          </Grid>
        </Grid>
      </Paper>

      <Divider sx={{ bgcolor: 'primary.light' }} />

      <Typography variant='h4' component='h2' gutterBottom align='center' sx={(theme) => ({ color: theme.palette.title.main })}>
        🎭 Spectacles précédents🎭
      </Typography>

      <Paper
        elevation={2}
        sx={{
          width: '100%'
        }}
      >
        {/* Divider */}
        <Grid item size={12}>
          <Divider sx={{ bgcolor: 'secondary.light' }} />
        </Grid>
        <Grid container spacing={2}>
          {/* Comme en 14 show */}
          <Grid ref={showRef1} size={{ xs: 12, sm: 8 }} sx={{ p: 3, position: 'relative' }}>
            <Typography
              variant='h6'
              color='text.secondary'
              sx={{
                position: 'absolute',
                top: 6,
                left: 24,
                fontStyle: 'bold'
              }}
            >
              Saison 2026–2027
            </Typography>
            <Typography paragraph sx={{ textAlign: 'left', mt: 4 }}>
              Après un succès retentissant lors de la saison 2025-2026, courronné par la première place au concours{' '}
              <Link href={'https://bruxellons.be/'}>Bruxellons</Link> dans la catégorie &quot;théâtre amateur&quot;, la compagnie Clair de
              Scène vous a proposé le spectacle <strong style={{ fontSize: '1.2em' }}>COMME EN 14</strong> de Dany Laurent.
            </Typography>
            <Typography paragraph sx={{ textAlign: 'left', p: 3, fontFamily: 'Georgia, serif' }}>
              Hiver 1917. Un hôpital juste derrière les lignes de front. 123 malades pour 2 infirmières. Les temps sont durs. Cependant 4
              femmes et un jeune garçon, réunis par le hasard de la guerre, vont fêter Noël malgré le bruit du canon et des blessés de
              l’autre côté du mur. La vie est plus forte que tout. On se heurte entre patriotisme et pacifisme. Mais surtout, on espère.
            </Typography>
            <Typography component='div' sx={{ textAlign: 'left' }}>
              <GoogleLocation show={karreveld} />
            </Typography>
            <Typography sx={{ textAlign: 'left' }}>
              <CalendarTodayIcon
                color='action'
                sx={{
                  mr: 2,
                  color: 'primary.main'
                }}
              />
              Le 25 septembre à 19:00
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, sm: 4 }} sx={{ display: 'flex', justifyContent: 'center' }}>
            <Box
              component='img'
              src='/commeEn14.jpeg'
              alt='Affiche du spectacle COMME EN 14'
              sx={{ width: '100%', maxWidth: 300, height: 'auto', borderRadius: 1, ml: 2 }}
            />
          </Grid>

          {/* Divider */}
          <Grid item size={12}>
            <Divider sx={{ bgcolor: 'secondary.light' }} />
          </Grid>
        </Grid>
      </Paper>
    </div>
  )
}

Shows.propTypes = {
  setSelectedTab: PropTypes.func.isRequired,
  scrollToShow: PropTypes.string
}
